var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('v-sheet',{attrs:{"outlined":"","rounded":""}},[_c('img',{staticClass:"d-block w-full h-auto rounded",attrs:{"src":_vm.src}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }